import { render, staticRenderFns } from "./StyleUsageModal.vue?vue&type=template&id=12b106d8&scoped=true&"
import script from "./StyleUsageModal.vue?vue&type=script&lang=ts&"
export * from "./StyleUsageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b106d8",
  null
  
)

export default component.exports